import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=43c72509&"
import script from "./UserGroupForm.vue?vue&type=script&lang=ts&"
export * from "./UserGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports